import { render, staticRenderFns } from "./FIBSvg.vue?vue&type=template&id=60a46d64&"
import script from "./FIBSvg.vue?vue&type=script&lang=js&"
export * from "./FIBSvg.vue?vue&type=script&lang=js&"
import style0 from "./FIBSvg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QColor from 'quasar/src/components/color/QColor.js';
import qInstall from "../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QColor});
